import React, { useState, useRef, useEffect } from "react";
import infoIcon from "../../../../assets/images/Icons/info_icon.svg";
import { makeAjax, showMessage, url, respStatus, matchValidateVersi } from '../../../../helpers/global_helper';
import { useSelector, useDispatch } from 'react-redux';
import ConfirmBetDeskonPopup from '../../../Popups/ConfirmBetDeskonPopup';
import BetSuccessPopup from '../../../Popups/BetSuccessPopup';
import ErrorPopup from '../../../Popups/ErrorPopup';
import ErrorInnerPopup from '../../../Popups/ErrorInnerPopup';
import { withTranslation } from "react-i18next";
import { formatPricewithdecimal, formatPrice } from "../../../NumberFormat";
import CancelledBetDeskonPopup from "../../../Popups/CancelledBetDeskonPopup";
import { getUserBalance, setCommonConfig } from "../../../../redux/actions";
import GameClosedPopup from "../GameClosedPopup";
import MarketClose from "../MarketClose";

const ShioVersiWap = (props) => {
  const dispatch = useDispatch();
  const gameId = useSelector((state) => state.CommonConfig.gameId);
  const gameType = useSelector((state) => state.CommonConfig.gameType);
  const betDiscount = useSelector((state) => state.CommonConfig.discount);
  const [showTooltip, setShowTooltip] = useState(false);
  const [betValues, setBetValues] = useState("");
  const [calculateTotal, setCalculateTotal] = useState({
    gameId: null,
    gameType: "shio",
    fastbet: true,
  });
  const [RespCalculateTotal, setRespCalculateTotal] = useState({});
  const [reqSubmitData, setReqSubmitData] = useState({
    gameId: null,
    action: "process",
    gameType: 'shio',
    fastbet: true,
    dataangka: [],
    betTogelAuth: "betTogelAuth"
  });
  const [showConfirmationPopup, setShowConfirmationPopup] = useState(false);
  const [errMessage, setErrorMessage] = useState('');
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [SubmitRespData, setSubmitRespData] = useState([]);
  const [successPopup, setSuccessPopup] = useState(false);
  const [showCancelledPopup, setShowCanclledPopup] = useState(false);
  const [totalCountClick, setTotalCountClick] = useState(false)
  const [reqData, setReqData] = useState({
    gameId: gameId,
    gameType: "shio",
  });
  const [shioText, setShioText] = useState([]);
  const [showGameClose, setShowGameClose] = useState(false);
  const [showMarketClose, setShowMarketClose] = useState(false);
  const betInputRef = useRef(null);
  const hideCommonToaster = () => {
    const commonToaster = document.getElementById("commonToaster");
    if (commonToaster) {
      commonToaster.style.display = "none";
    }
  };

  useEffect(() => {
    makeAjax(url.TOGEL_API.getTogelGame, reqData).then(response => {
      if (response.status !== respStatus['SUCCESS']) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }

        if (response.code !== "validation_error") {
          setErrorMessage(props.t(response.code));
          setShowErrorPopup(true);
          return;
        }
        showMessage("server error No data find", "error", "error");
        return;
      }
      setShioText(response.data.shio);
    })
  }, [reqData]);

  const toggleTooltip = () => {
    setShowTooltip(!showTooltip);
  };

  const handleInputChange = (e) => {
    setBetValues(e.target.value);
  };

  useEffect(() => {
    setCalculateTotal((prevReqData) => ({
      ...prevReqData,
      gameId: gameId,
      databet: betValues,
      multiple:betDiscount.showMultiple
    }));
  }, [betValues]);

  const submitCalculateTotal = () => {
    if (!calculateTotal.databet) {
      setErrorMessage(props.t('format_input'));
      setShowErrorPopup(true);
      return;
    }

    let matchValidate = matchValidateVersi(gameType, calculateTotal.databet);
    if (matchValidate) {
      setErrorMessage(props.t(matchValidate));
      setShowErrorPopup(true);
      return;
    }

    makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then(response => {
      if (response.status !== respStatus['SUCCESS']) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }

        showMessage(props.t(response.code), "error", "error");
        return;
      }
      setRespCalculateTotal(response.data);
      setTotalCountClick(true)
      const newAngakas = response.data.dataangka.map(item => [item.nomor, item.taruhan, item.status]);
      setReqSubmitData((prevState) => ({
        ...prevState,
        gameId: gameId,
        dataangka: newAngakas,
      }));
    });
  }

  useEffect(() => {
    allDataReset()
  }, [gameId])



  const allDataReset = () => {
    setBetValues("");
    setRespCalculateTotal({});
    setCalculateTotal({
      gameId: null,
      gameType: "shio",
      fastbet: true,
    });
    setReqSubmitData({
      gameId: null,
      action: "process",
      gameType: 'shio',
      fastbet: true,
      dataangka: [],
      betTogelAuth: "betTogelAuth"
    });
    setTotalCountClick(false);
    if (betInputRef.current) betInputRef.current.value = '';
    setSubmitRespData([]);
  }

  const submitProcess = () => {
    if (totalCountClick) {
      setShowConfirmationPopup(true)
    } else {
      if (!calculateTotal.databet) {
        setErrorMessage(props.t('format_input_wrong'));
        setShowErrorPopup(true);
        return;
      }

      let matchValidate = matchValidateVersi(gameType, calculateTotal.databet);
      if (matchValidate) {
        setErrorMessage(props.t(matchValidate));
        setShowErrorPopup(true);
        return;
      }

      makeAjax(url.TOGEL_API.processDataBet, calculateTotal).then(response => {
        if (response.status !== respStatus['SUCCESS']) {
          if (response.code === "sub_game_status_close") {
            setShowGameClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
            return;
          }
          if (response.code === "market_close_err") {
            setShowMarketClose(true);
            showMessage(false);
            hideCommonToaster();
            dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
            return;
          }

          setErrorMessage(props.t(response.code), "error", "error");
          setShowErrorPopup(true)
          return;
        }
        setRespCalculateTotal(response.data);
        const newAngakas = response.data.dataangka.map(item => [item.nomor, item.taruhan, item.status]);
        setReqSubmitData((prevState) => ({
          ...prevState,
          gameId: gameId,
          dataangka: newAngakas,
        }));
        setShowConfirmationPopup(true);
      });
    }
    // if (reqSubmitData.dataangka.length > 0) {
    //   setShowConfirmationPopup(true);
    // } else {
    //   setErrorMessage('Incorrect Input Format');
    //   setShowErrorPopup(true);
    // }
  }

  const submitProcessOk = () => {
    setShowConfirmationPopup(false);
    makeAjax(url.TOGEL_API.processAltTogel, reqSubmitData).then(response => {
      if (response.status !== respStatus['SUCCESS']) {
        if (response.code === "sub_game_status_close") {
          setShowGameClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "subGameOnOffStatus", value: 0 }));
          return;
        }
        if (response.code === "market_close_err") {
          setShowMarketClose(true);
          showMessage(false);
          hideCommonToaster();
          dispatch(setCommonConfig({ key: "marketCloseStatus", value: 0 }));
          return;
        }

        setErrorMessage(props.t(response.code))
        setShowErrorPopup(true);
        return;
      }
      allDataReset();
      setSubmitRespData(prevData => [...prevData, response.data]);
      dispatch(getUserBalance());
      setSuccessPopup(true);
    });
  }

  const hanldeConfirmationPopupClose = () => {
    setShowConfirmationPopup(false);
    setShowCanclledPopup(true)
  }

  const shioCodes = shioText.map(shio => `${shio.sort} = ${shio.name}`).join(', ');

  return (
    <div className="versiwrapper">
      {showGameClose ? (
        <GameClosedPopup />
      ) : showMarketClose ? (
        <MarketClose />
      ) : (
        <>
          {/* --- Rules ---  */}
          <div className='rules_container'>
            <div>
              <p>{props.t('shio_2d')}</p>
              <p>Format Tarun: Posisi1*Posisi2#bet+Posisi5Posisi7#bet</p>
              <p>Conoth Penulisan: 1*2*3+harimau*kuda#1</p>
              {/* <p>kode Shio: 1 =kelinci, 2 =harimau, 3 =kerbau, 4 =tikus, 5 =babi, 6 = anjing, 7 = ayam, 8 = monyet, 9 =kambing, 10 =kuda, 11 =ular, 12 =naga,</p> */}
              <p>kode Shio: {shioCodes}</p>
            </div>
            <div className='rules_conversion'>
              <p>Konversi <br /> 1 = {betDiscount.showMultiple}</p>
            </div>
          </div>
          {/* --- Rules ---  */}
          <div className="versicontainer">
            <textarea
              rows="20"
              placeholder="1*2*3#1+harimau*kuda#1"
              ref={betInputRef}
              onChange={handleInputChange}
            ></textarea>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="result_left">
                <p>
                  <span>Total {props.t('line')}</span> : {RespCalculateTotal.line ? RespCalculateTotal.line : "-"}
                </p>
                <p>
                  <span>Total {props.t('purchases')}</span> : {RespCalculateTotal.tover ? formatPrice(RespCalculateTotal.tover) : "-"} &nbsp;
                </p>
              </div>
              <div className="result_right">
                <p>
                  <span>{props.t('total')} {props.t('discount')}</span>: {RespCalculateTotal.disc ? formatPrice(RespCalculateTotal.disc) : "-"}
                </p>
                <p>
                  <span>Total {props.t('payment')}</span> : {RespCalculateTotal.pay ? formatPrice(RespCalculateTotal.pay) : "-"}
                </p>
              </div>
              <div className='info_icon'>
                <img
                  src={infoIcon}
                  alt=""
                  onClick={toggleTooltip}
                />
                {showTooltip && (<div className="info_icon_overlay" onClick={() => setShowTooltip(false)}></div>)}
                {showTooltip && (
                  <span className="tooltip">
                    <div className="tooltip_wrapper">
                      <span className="tooltip_heading">Contoh Format Taruhan</span>
                      <span className="tooltip_content">1*2*3#1+harimau*kuda#1</span>
                    </div>
                  </span>
                )}
              </div>
            </div>
            <div className="versiweb_result_right">
              <p>
                Konversi<br></br> 1 = {betDiscount.showMultiple}
              </p>
            </div>
          </div>
          <div className="versiweb_resultwrapper">
            <div className="versiweb_result_left">
              <div className="button_left">
                <button onClick={submitCalculateTotal}>{props.t('count_total')}</button>
              </div>
              <div className="button_right">
                <button onClick={allDataReset}>{props.t('reset')}</button>
              </div>
            </div>
            <div className="versiweb_result_right">
              <button onClick={submitProcess}>{props.t('submit')}</button>
            </div>
            {showConfirmationPopup && (
              <ConfirmBetDeskonPopup
                onClose={hanldeConfirmationPopupClose} submitProcessOk={submitProcessOk}
              />
            )}
            {successPopup && (
              <div className="popup-overlay ">
                <BetSuccessPopup response={SubmitRespData} onClose={() => setSuccessPopup(false)} />
              </div>
            )}
            {showErrorPopup && (
              <ErrorInnerPopup
                modalTitle={""}
                modalHeader={true}
                onCloseModal={() => setShowErrorPopup(false)}
              >
                <ErrorPopup message={errMessage} onClose={() => setShowErrorPopup(false)} />
              </ErrorInnerPopup>
            )}

            {showCancelledPopup && (
              <CancelledBetDeskonPopup
                onClose={() => setShowCanclledPopup(false)}
              />
            )}
          </div>
        </>
      )}

    </div>
  );
};

export default withTranslation()(ShioVersiWap);
